import {
  PracticeCompleteness,
  PracticeAffiliate,
  PracticeInvite,
  PracticeRate,
  AdpSamlResponse,
  PracticeActivationData,
  PracticeInviteDetails,
  LiabilityInsurance,
  PracticeAffiliateStatusEnum,
} from "../../../domain/Practice/schema"
import {
  EnumTableData,
  GovernmentTaxTypeMap,
  TaxOrganizationTypeMap,
} from "../../../domain/CMS/schema"
import {
  PracticeRole,
  PracticeRoleEnum,
} from "../../../domain/Account/userSlice"
import {
  ContactInfoResponse,
  BasePracticeResponse,
} from "../../../domain/Practice/loaders/practiceInformation"
import {
  PracticeAgreementReturn,
  KnoxKeeneAgreementReturn,
} from "../../../domain/PracticeProviders/usePracticeAgreementsData"
import { PracticeBillingAddressReturn } from "../../../domain/PracticeProviders/usePracticeBillingAddressData"
import {
  FullPractice,
  PartialPractice,
  TaxInfo,
} from "../../../domain/Practices/schema"
import {
  buildUrl,
  buildURLWithQueryParams,
  deleteData,
  getData,
  getFile,
  PagedResult,
  postData,
  postDataFlexibleTyped,
  postFormData,
  putData,
  putDataTyped,
} from "../apiService"
import { FileStatusDisplayIdEnum } from "../../../domain/Files/schema"
import { getContentAndStatus } from "../apiService"
import { PublicPractice } from "../../../domain/Profile/schema"
import { LocationThumbnailParams } from "../../../domain/Referral/schema"
import { getRouteWithQueryParams } from "../../../routes"
import { PracticeName } from "../../../domain/Practice/loaders/loader"
import {
  IrsStatusValues,
  TinValidationStatusValues,
} from "../../../domain/TinValidation/schema"

const apiRoutes = {
  get: {
    ADP_SAML_BY_LEGACY_AFFILIATE_ID_ROUTE:
      "/practice/adpsaml/:legacyAffiliateId",
    PRACTICE_BY_ID_ROUTE: "/practice/practices/:practiceId",
    PRACTICE_COMPLETENESS_BY_ID_ROUTE:
      "/practice/practices/:practiceId/completeness",
    PRACTICE_BILLING_ADDRESS_ROUTE:
      "/practice/practices/:practiceId/billingaddress",
    PRACTICE_CONTACT_INFO_ROUTE: "/practice/practices/:practiceId/contactinfo",
    PRACTICE_TAGS_ROUTE: "/practice/practices/:practiceId/tags",
    PRACTICE_AGREEMENT_ROUTE:
      "/practice/practices/:practiceId/practiceagreement",
    PRACTICE_AGREEMENT_HISTORY_ROUTE:
      "/practice/practices/:practiceId/practiceagreement/history",
    PRACTICE_KNOX_KEENE_AGREEMENT_ROUTE:
      "/practice/practices/:practiceId/knoxkeeneagreement",
    PRACTICE_KNOX_KEENE_AGREEMENT_HISTORY_ROUTE:
      "/practice/practices/:practiceId/knoxkeeneagreement/history",
    FULL_PRACTICE_BY_ID_ROUTE: "/practice/practices/:practiceId/fullPractice",
    PARTIAL_PRACTICE_BY_ID_ROUTE:
      "/practice/practices/:practiceId/partialPractice",
    PRACTICE_AFFILIATES_ROUTE: "/practice/practices/:practiceId/affiliates",
    PRACTICE_PUBLIC_AFFILIATES_ROUTE: "/practice/public/:practiceId/affiliates",
    PRACTICE_AFFILIATES_BY_USER_ID_ROUTE: "/practice/affiliates/users/:userId",
    PRACTICE_AFFILIATE_BY_PROVIDER_ID_ROUTE:
      "/practice/affiliates/providers/:providerId",
    PUBLIC_PRACTICES_BY_PROVIDER_USER_ID_ROUTE:
      "/practice/public/providers/:userId/practices",
    PUBLIC_PRACTICES_BY_PROVIDER_PROVIDER_ID_ROUTE:
      "/practice/public/providers/practices/:providerId",
    PRACTICE_ACTIVATION_DATA: "/practice/practices/activationData",
    PRACTICE_NAMES: "/practice/practicenames",
    PRACTICE_NAMES_BY_USER_ID: "/practice/practices/names/:userId",
    PRACTICE_NAMES_BY_UNREGISTERED_PROVIDER_ID:
      "/practice/practices/names/unregistered/:providerId",
    PRACTICE_LOCATIONS_PHOTOS: "/practice/locations/:locationId/photos",
    PRACTICE_LOCATION_FULL_PHOTO: "/practice/locationPhoto/:photoId/content",
    PRACTICE_LOCATION_PHOTO_THUMBNAIL:
      "/practice/locationPhoto/:photoId/thumbnail",
    PRACTICE_LIABILITY_INSURANCES_BY_ID_ROUTE:
      "/practice/practices/:practiceId/liabilityinsurances",
    PUBLIC_PRACTICE_BY_ID_ROUTE: "/practice/public/practices/:practiceId",
    PRACTICE_INVITES_DETAILS_BY_INVITE_CODE_ROUTE:
      "/practice/practices/invites/invitecode/:inviteCode",
    PRACTICE_INVITES_BY_INVITE_ID_ROUTE:
      "/practice/practices/:practiceId/invites/:inviteId",
    PRACTICE_INVITE_BY_INVITE_ID_ROUTE: "/practice/practices/invite/:inviteId",
    PRACTICE_RATES_ROUTE: "/practice/practices/:practiceId/rates",
    PRACTICE_ACTIVE_RATE_ROUTE: "/practice/practices/:practiceId/activerate",
    PRACTICE_AUTH_AND_RELEASE_SIGNED_DOC_ROUTE:
      "/practice/practices/:practiceId/authRelease/content",
    PRACTICE_TAX_DOCUMENT_ROUTE:
      "/practice/practices/:practiceId/taxinfodocument",
    PRACTICE_TAX_INFO_ROUTE: "/practice/practices/:practiceId/taxinfo",
    PRACTICE_AGREEMENT_DOCUMENT_ROUTE:
      "/practice/practices/:practiceId/practiceagreement/content",
    PRACTICE_KNOX_KEENE_DOCUMENT_ROUTE:
      "/practice/practices/:practiceId/knoxkeeneagreement/content",
    PRACTICE_TABLE_DATA: "/practice/tableData",
    CHECK_DUPLICATE_TAX_ID: "/practice/taxinfo/exists/:practiceId/:taxId",
    PRACTICE_ROLES_BY_USER_ID_ROUTE: "/practice/practices/allroles/:userId",
    PRACTICE_ROLES_BY_UNREGISTERED_PROVIDER_ID_ROUTE:
      "/practice/practices/allroles/unregistered/:providerId",
  },
  post: {
    PRACTICE_ROUTE: "/practice/practices",
    PRACTICE_INVITE_ROUTE: "/practice/practices/:practiceId/invites",
    PRACTICE_INVITE_ACCEPT_ROUTE:
      "/practice/practices/:practiceId/invites/:inviteId/accept",
    PRACTICE_INVITE_DECLINE_ROUTE:
      "/practice/practices/:practiceId/invites/:inviteId/decline",
    PRACTICE_AFFILIATES: "/practice/affiliates",
    PRACTICE_AFFILIATES_BY_USER_IDS_BATCH_ROUTE:
      "/practice/affiliates/users/batch",
    PARTIAL_PRACTICES_BY_IDS_BATCH_ROUTE:
      "/practice/practices/partialPractices/batch",
    PRACTICE_TAX_INFORMATION: "/practice/practices/:practiceId/taxinfo",
  },
  put: {
    PRACTICE_INVITE_ROUTE: "/practice/practices/:practiceId/invites/:inviteId",
    PRACTICE_INVITE_ADD_USER_ROUTE:
      "/practice/practices/:practiceId/invites/:inviteId/addUser/:userId",
    PRACTICE_INVITE_REMOVE_USER_ROUTE:
      "/practice/practices/:practiceId/invites/:inviteId/removeUser/:userId",
    PRACTICE_INVITE_ADD_USER_TO_ALL_DETACHED_ROUTE:
      "/practice/practices/invites/linkAllByEmail",
    PRACTICE_RATE_ROUTE: "/practice/practices/:practiceId/rate",
    PRACTICE_ACTIVE_RATE_ROUTE: "/practice/practices/:practiceId/activerate",
    PRACTICE_ADP_RECOVERY: "/practice/practices/:practiceId/adpRecovery",
    PRACTICE_AFFILIATE_ROLES_ROUTE: "/practice/affiliates/:affiliateId/roles",
    PRACTICE_AFFILIATE_STATUS_ROUTE: "/practice/affiliates/:affiliateId/status",
    PRACTICE_ACTIVATION_ROUTE: "/practice/practices/:practiceId/activate",
    PRACTICE_TAX_INFORMATION:
      "/practice/practices/:practiceId/taxinfo/:taxInfoId",
  },
  delete: {
    PRACTICE_AFFILIATE: "/practice/affiliates/:affiliateId",
    PRACTICE_INVITE: "/practice/practices/:practiceId/invites/:inviteId",
  },
}

export interface PostBasePracticePayload {
  name: string
  isVisible?: boolean
  websiteUrl?: string
  overview?: string
  practiceTypeDisplayId: string
}

export interface LegacyDto {
  legacyAffiliateId?: number
  legacyLocationId?: number
}

const fullPracticeById = async ({ practiceId }: { practiceId: string }) => {
  return getData<FullPractice>(
    buildURLWithQueryParams(
      apiRoutes.get.FULL_PRACTICE_BY_ID_ROUTE,
      { practiceId },
      { "api-version": "2.0" },
    ),
  )
}

const partialPracticeById = async ({ practiceId }: { practiceId: string }) => {
  return getData<PartialPractice>(
    buildUrl(apiRoutes.get.PARTIAL_PRACTICE_BY_ID_ROUTE, {
      practiceId,
    }),
  )
}

const partialPracticesByIds = async (
  practiceIds: string[],
): Promise<PartialPractice[]> => {
  const practices: PartialPractice[] = []
  const errors: Error[] = []
  for (const practiceId of practiceIds) {
    try {
      const practice = await getData<PartialPractice>(
        buildUrl(apiRoutes.get.PARTIAL_PRACTICE_BY_ID_ROUTE, {
          practiceId,
        }),
      )
      practices.push(practice)
    } catch (error) {
      errors.push(error instanceof Error ? error : new Error(String(error)))
    }
  }
  if (errors.length > 0) {
    const errorMessage = errors.map((error) => error.message).join("\n")
    throw new Error(`Failed to fetch practices:\n${errorMessage}`)
  }
  return practices
}

const partialPracticesByIdsBatch = async (practiceIds: string[]) => {
  return getData<PartialPractice[]>(
    buildUrl(apiRoutes.post.PARTIAL_PRACTICES_BY_IDS_BATCH_ROUTE),
    true,
    practiceIds,
  )
}

const fullPracticesByIds = async (
  practiceIds: string[],
): Promise<FullPractice[]> => {
  const practices: FullPractice[] = []
  const errors: Error[] = []
  for (const practiceId of practiceIds) {
    try {
      const practice = await getData<FullPractice>(
        buildURLWithQueryParams(
          apiRoutes.get.FULL_PRACTICE_BY_ID_ROUTE,
          { practiceId },
          { "api-version": "2.0" },
        ),
      )
      practices.push(practice)
    } catch (error) {
      errors.push(error instanceof Error ? error : new Error(String(error)))
    }
  }
  if (errors.length > 0) {
    const errorMessage = errors.map((error) => error.message).join("\n")
    throw new Error(`Failed to fetch practices:\n${errorMessage}`)
  }
  return practices
}

const practiceCompletenessById = async ({
  practiceId,
  apiVersion = "1.0",
}: {
  practiceId: string
  apiVersion?: string
}) => {
  return getData<PracticeCompleteness>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_COMPLETENESS_BY_ID_ROUTE,
      { practiceId },
      { "api-version": apiVersion },
    ),
  )
}

const practiceContactInfoById = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<ContactInfoResponse>(
    buildUrl(apiRoutes.get.PRACTICE_CONTACT_INFO_ROUTE, { practiceId }),
  )
}

const practiceTagsById = async ({ practiceId }: { practiceId: string }) => {
  return getData<string[]>(
    buildUrl(apiRoutes.get.PRACTICE_TAGS_ROUTE, { practiceId }),
  )
}

const practiceAgreementByPracticeId = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<PracticeAgreementReturn>(
    buildUrl(apiRoutes.get.PRACTICE_AGREEMENT_ROUTE, { practiceId }),
  )
}

const practiceAgreementHistory = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<PracticeAgreementReturn[]>(
    buildUrl(apiRoutes.get.PRACTICE_AGREEMENT_HISTORY_ROUTE, {
      practiceId,
    }),
  )
}

const practiceKnoxKeeneAgreementByPracticeId = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<KnoxKeeneAgreementReturn>(
    buildUrl(apiRoutes.get.PRACTICE_KNOX_KEENE_AGREEMENT_ROUTE, {
      practiceId,
    }),
  )
}

const practiceKnoxKeeneAgreementHistory = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<KnoxKeeneAgreementReturn[]>(
    buildUrl(apiRoutes.get.PRACTICE_KNOX_KEENE_AGREEMENT_HISTORY_ROUTE, {
      practiceId,
    }),
  )
}

const practiceBillingAddressByPracticeId = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<PracticeBillingAddressReturn>(
    buildUrl(apiRoutes.get.PRACTICE_BILLING_ADDRESS_ROUTE, {
      practiceId,
    }),
  )
}

const publicPracticeById = async ({ practiceId }: { practiceId: string }) => {
  return getData<PublicPractice>(
    buildUrl(apiRoutes.get.PUBLIC_PRACTICE_BY_ID_ROUTE, { practiceId }),
  )
}

const practiceAffiliates = async ({ practiceId }: { practiceId: string }) => {
  return getData<PracticeAffiliate[]>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_AFFILIATES_ROUTE,
      { practiceId },
      { "api-version": "2.0" },
    ),
  )
}

const practicePublicAffiliates = async ({
  practiceId,
  onlyProviders,
}: {
  practiceId: string
  onlyProviders: string
}) => {
  return getData<PracticeAffiliate[]>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_PUBLIC_AFFILIATES_ROUTE,
      { practiceId },
      { onlyProviders, "api-version": "2.0" },
    ),
  )
}

const publicPracticesByProviderUserId = async ({
  userId,
}: {
  userId: string
}) => {
  return getData<PublicPractice[]>(
    buildUrl(apiRoutes.get.PUBLIC_PRACTICES_BY_PROVIDER_USER_ID_ROUTE, {
      userId,
    }),
  )
}

const publicPracticesByProviderProviderId = async ({
  providerId,
}: {
  providerId: string
}) => {
  return getData<PublicPractice[]>(
    buildUrl(apiRoutes.get.PUBLIC_PRACTICES_BY_PROVIDER_PROVIDER_ID_ROUTE, {
      providerId,
    }),
  )
}

const practiceActivationData = async ({
  pageNumber,
  pageSize,
}: {
  pageNumber: string
  pageSize: string
}) => {
  return getData<PagedResult<PracticeActivationData>>(
    buildURLWithQueryParams(apiRoutes.get.PRACTICE_ACTIVATION_DATA, undefined, {
      pageNumber,
      pageSize,
    }),
  )
}

const practiceNamesByStatus = async ({ status }: { status: string }) => {
  return getData<PracticeName[]>(
    buildURLWithQueryParams(apiRoutes.get.PRACTICE_NAMES, undefined, {
      statusFilter: status,
    }),
  )
}

const practiceNamesByUserId = async ({ userId }: { userId: string }) => {
  return getData<PracticeName[]>(
    buildUrl(apiRoutes.get.PRACTICE_NAMES_BY_USER_ID, { userId }),
  )
}

const practiceNamesByUnregisteredProviderId = async ({
  providerId,
}: {
  providerId: string
}) => {
  return getData<PracticeName[]>(
    buildUrl(apiRoutes.get.PRACTICE_NAMES_BY_UNREGISTERED_PROVIDER_ID, {
      providerId,
    }),
  )
}

const practiceLocationFullPhotoByPhotoId = async (
  params: LocationThumbnailParams,
) => {
  const { photoId, practiceId } = params
  const urlWithUrlParams = buildUrl(
    apiRoutes.get.PRACTICE_LOCATION_FULL_PHOTO,
    {
      photoId,
    },
  )
  const fullUrl = getRouteWithQueryParams(urlWithUrlParams, { practiceId })
  return getData<Blob>(fullUrl, false, undefined, true)
}

const practiceLocationThumbnailByPhotoId = async (
  params: LocationThumbnailParams,
) => {
  const { photoId, practiceId } = params
  const urlWithUrlParams = buildUrl(
    apiRoutes.get.PRACTICE_LOCATION_PHOTO_THUMBNAIL,
    {
      photoId,
    },
  )
  const fullUrl = getRouteWithQueryParams(urlWithUrlParams, { practiceId })
  return getData<Blob>(fullUrl, false, undefined, true)
}

export interface PracticePhotoThumbnailResult {
  fileStatus: FileStatusDisplayIdEnum
  fileBlob?: Blob
}

/**
 * Fetch a practice location photo thumbnail with explicit status handling.
 * This mirrors the specialized behavior in practiceProfile/OfficeInfo/helpers.ts
 * and is exposed here so other callers of practiceApi can use the same
 * 200 => AVAILABLE (returns blob), 202 => PROCESSING, 410 => QUARANTINED semantics.
 *
 * @param photoId - id of the photo to fetch
 * @param practiceId - practice id used as a query param
 * @returns an object with fileStatus and optional fileBlob (when AVAILABLE)
 * @throws on unexpected HTTP status or network errors
 */
export const fetchPracticeLocationPhotoThumbnail = async (
  photoId: string,
  practiceId: string,
): Promise<PracticePhotoThumbnailResult> => {
  const urlWithUrlParams = buildUrl(
    apiRoutes.get.PRACTICE_LOCATION_PHOTO_THUMBNAIL,
    {
      photoId,
    },
  )
  const fullUrl = getRouteWithQueryParams(urlWithUrlParams, { practiceId })

  // Delegate to shared apiService helper which handles 200/202/410 semantics
  const result = await getContentAndStatus(fullUrl)
  if (result.status === FileStatusDisplayIdEnum.AVAILABLE) {
    return { fileStatus: result.status, fileBlob: result.data }
  }
  return { fileStatus: result.status }
}

const practiceAffiliatesByUserId = async ({
  userId,
  includeDeactivated,
}: {
  userId: string
  includeDeactivated?: boolean
}) => {
  const query: Record<string, string> = { "api-version": "2.0" }
  if (includeDeactivated) {
    query.includeDeactivated = String(includeDeactivated)
  }
  return getData<PracticeAffiliate[]>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_AFFILIATES_BY_USER_ID_ROUTE,
      { userId },
      query,
    ),
  )
}

const practiceAffiliatesByUserIdsBatch = async ({
  userIds,
}: {
  userIds: string[]
}) => {
  return getData<PracticeAffiliate[]>(
    buildURLWithQueryParams(
      apiRoutes.post.PRACTICE_AFFILIATES_BY_USER_IDS_BATCH_ROUTE,
      undefined,
      { "api-version": "2.0" },
    ),
    true,
    userIds,
  )
}

const practiceAffiliateByProviderId = async ({
  providerId,
}: {
  providerId: string
}) => {
  return getData<PracticeAffiliate>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_AFFILIATE_BY_PROVIDER_ID_ROUTE,
      { providerId },
      { "api-version": "2.0" },
    ),
  )
}

const practiceLiabilityInsurancesById = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getData<LiabilityInsurance[]>(
    buildUrl(apiRoutes.get.PRACTICE_LIABILITY_INSURANCES_BY_ID_ROUTE, {
      practiceId,
    }),
  )
}

// Note: practices/invites/invitecode/:inviteCode is v1-only on the backend; no api-version
// query param is sent here.
const practiceInviteDetailsByInviteCode = async ({
  inviteCode,
}: {
  inviteCode: string
}) => {
  return getData<PracticeInviteDetails>(
    buildUrl(apiRoutes.get.PRACTICE_INVITES_DETAILS_BY_INVITE_CODE_ROUTE, {
      inviteCode,
    }),
  )
}

const practiceInvitesByInviteId = async ({
  practiceId,
  inviteId,
}: {
  practiceId: string
  inviteId: string
}) => {
  return getData<PracticeInvite>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_INVITES_BY_INVITE_ID_ROUTE,
      { practiceId, inviteId },
      { "api-version": "2.0" },
    ),
  )
}

// Note: this endpoint path has no backend match in either v1 or v2 — left untouched.
const practiceInviteByInviteId = async ({ inviteId }: { inviteId: string }) => {
  return getData<PracticeInvite>(
    buildUrl(apiRoutes.get.PRACTICE_INVITE_BY_INVITE_ID_ROUTE, {
      inviteId,
    }),
  )
}

const practiceRates = async ({ practiceId }: { practiceId: string }) => {
  return getData<PracticeRate[]>(
    buildUrl(apiRoutes.get.PRACTICE_RATES_ROUTE, { practiceId }),
  )
}

const practiceActiveRate = async ({ practiceId }: { practiceId: string }) => {
  return getData<PracticeRate>(
    buildURLWithQueryParams(
      apiRoutes.get.PRACTICE_ACTIVE_RATE_ROUTE,
      { practiceId },
      {
        "api-version": "2.0",
      },
    ),
  )
}

const authAndReleaseSignedDoc = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getFile<Blob>(
    buildUrl(apiRoutes.get.PRACTICE_AUTH_AND_RELEASE_SIGNED_DOC_ROUTE, {
      practiceId,
    }),
    undefined,
    undefined,
    true,
  )
}

const taxDocument = async ({ practiceId }: { practiceId: string }) => {
  return getFile<Blob>(
    buildUrl(apiRoutes.get.PRACTICE_TAX_DOCUMENT_ROUTE, { practiceId }),
    undefined,
    undefined,
    true,
  )
}

const taxInfo = async ({ practiceId }: { practiceId: string }) => {
  return getData<TaxInfo>(
    buildUrl(apiRoutes.get.PRACTICE_TAX_INFO_ROUTE, { practiceId }),
  )
}

const practiceAgreementDocument = async ({
  practiceId,
}: {
  practiceId: string
}) => {
  return getFile<Blob>(
    buildUrl(apiRoutes.get.PRACTICE_AGREEMENT_DOCUMENT_ROUTE, {
      practiceId,
    }),
    undefined,
    undefined,
    true,
  )
}

const knoxKeeneDocument = async ({ practiceId }: { practiceId: string }) => {
  return getFile<Blob>(
    buildUrl(apiRoutes.get.PRACTICE_KNOX_KEENE_DOCUMENT_ROUTE, {
      practiceId,
    }),
    undefined,
    undefined,
    true,
  )
}

const practiceTableData = async () => {
  return getData<EnumTableData>(buildUrl(apiRoutes.get.PRACTICE_TABLE_DATA))
}

const checkDuplicateTaxId = async (practiceId: string, taxId: string) => {
  return getData<boolean>(
    buildUrl(apiRoutes.get.CHECK_DUPLICATE_TAX_ID, {
      practiceId: practiceId,
      taxId: taxId,
    }),
  )
}

const practiceRolesByUserId = async ({ userId }: { userId: string }) => {
  return getData<{ id: string; roles: PracticeRole[] }[]>(
    buildUrl(apiRoutes.get.PRACTICE_ROLES_BY_USER_ID_ROUTE, { userId }),
  )
}

const practiceRolesByUnregisteredProviderId = async ({
  providerId,
}: {
  providerId: string
}) => {
  return getData<{ id: string; roles: PracticeRole[] }[]>(
    buildUrl(apiRoutes.get.PRACTICE_ROLES_BY_UNREGISTERED_PROVIDER_ID_ROUTE, {
      providerId,
    }),
  )
}

const adpSamlByLegacyAffiliateId = async ({
  legacyAffiliateId,
}: {
  legacyAffiliateId: number
}) => {
  return getData<AdpSamlResponse>(
    buildUrl(apiRoutes.get.ADP_SAML_BY_LEGACY_AFFILIATE_ID_ROUTE, {
      legacyAffiliateId: legacyAffiliateId.toString(),
    }),
  )
}

const practiceById = async ({ practiceId }: { practiceId: string }) => {
  return getData<BasePracticeResponse>(
    buildUrl(apiRoutes.get.PRACTICE_BY_ID_ROUTE, { practiceId }),
  )
}

const postPractice = async (
  payload: PostBasePracticePayload,
): Promise<BasePracticeResponse> => {
  const url = apiRoutes.post.PRACTICE_ROUTE
  return postDataFlexibleTyped(url, payload)
}

const postPracticeInvite = async (
  practiceId: string,
  practiceInvite: Omit<
    PracticeInvite,
    | "id"
    | "practiceName"
    | "invitedDate"
    | "practiceProvidesLiabilityInsurance"
    | "createdBy"
    | "practiceHasActiveInsurance"
  >,
) => {
  return postData<
    Omit<
      PracticeInvite,
      | "id"
      | "practiceName"
      | "invitedDate"
      | "practiceProvidesLiabilityInsurance"
      | "createdBy"
    >
  >(
    buildURLWithQueryParams(
      apiRoutes.post.PRACTICE_INVITE_ROUTE,
      { practiceId },
      { "api-version": "2.0" },
    ),
    practiceInvite,
  )
}

// v3 accept-invite — returns the v2 invite shape (no practiceId/providerId on the wire) and
// accepts an optional `providerId` in the body for provider-role invites.
const postAcceptPracticeInvite = async ({
  practiceId,
  inviteId,
  body = {},
}: {
  practiceId: string
  inviteId: string
  body?: { providerId?: string }
}) => {
  return postData<PracticeInvite>(
    buildURLWithQueryParams(
      apiRoutes.post.PRACTICE_INVITE_ACCEPT_ROUTE,
      {
        practiceId,
        inviteId,
      },
      { "api-version": "3.0" },
    ),
    body,
  )
}

const postManagedPracticeAffiliate = async ({
  providerId,
  practiceId,
}: {
  providerId: string
  practiceId: string
}) => {
  return postData<PracticeAffiliate>(
    buildURLWithQueryParams(apiRoutes.post.PRACTICE_AFFILIATES, undefined, {
      "api-version": "2.0",
    }),
    {
      providerId,
      practiceId,
      roleDisplayIds: [PracticeRoleEnum.PROVIDER],
      statusDisplayId: "pending",
    },
  )
}

export interface PostTaxInfoRequest {
  governmentTaxId?: string
  governmentTaxType?: keyof GovernmentTaxTypeMap
  taxOrganizationType?: keyof TaxOrganizationTypeMap
  legalName?: string
  alternateTaxName?: string
  tinValidationError?: string
  tinValidatedDateTime?: string
  tinValidatedBy?: string
  tinValidationStatus?: TinValidationStatusValues
  irsStatus?: IrsStatusValues
  file?: Blob
  fileName?: string
}
export interface TaxInfoDto {
  id: string
  governmentTaxId?: string
  governmentTaxType?: keyof GovernmentTaxTypeMap
  taxOrganizationType?: keyof TaxOrganizationTypeMap
  legalName?: string
  alternateTaxName?: string
  fileId?: string
  fileName?: string
  fileStatus?: FileStatusDisplayIdEnum
  createdBy?: string
  createdDateTime: string
  lastUpdatedBy?: string
  lastUpdatedDateTime: string
  tinValidationStatus?: TinValidationStatusValues
  irsStatus?: IrsStatusValues
  tinValidationError?: string
  tinValidatedDateTime?: string
  tinValidatedBy?: string
}
const postPracticeTaxInformation = async (
  practiceId: string,
  taxInfo: FormData,
) => {
  return postFormData<TaxInfoDto>(
    buildUrl(apiRoutes.post.PRACTICE_TAX_INFORMATION, { practiceId }),
    taxInfo,
  )
}

const putPracticeAdpRecovery = async (
  practiceId: string,
  adpRecoveryRequest: { taxId: string },
) => {
  return putData(
    buildUrl(apiRoutes.put.PRACTICE_ADP_RECOVERY, { practiceId }),
    adpRecoveryRequest,
  )
}

const postDeclinePracticeInvite = async ({
  practiceId,
  inviteId,
}: {
  practiceId: string
  inviteId: string
}) => {
  return postData(
    buildURLWithQueryParams(
      apiRoutes.post.PRACTICE_INVITE_DECLINE_ROUTE,
      { practiceId, inviteId },
      { "api-version": "2.0" },
    ),
    {},
  )
}

const putPracticeInvite = async (
  practiceId: string,
  inviteId: string,
  updatedPracticeInvite: PracticeInvite,
) => {
  return putData<PracticeInvite>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_INVITE_ROUTE,
      { practiceId, inviteId },
      { "api-version": "2.0" },
    ),
    updatedPracticeInvite,
  )
}

const putPracticeInviteAddUser = async (
  practiceId: string,
  inviteId: string,
  userIdToAdd: string,
) => {
  return putDataTyped<PracticeInvite>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_INVITE_ADD_USER_ROUTE,
      { practiceId, inviteId, userId: userIdToAdd },
      { "api-version": "2.0" },
    ),
    {},
  )
}

const putPracticeInviteRemoveUser = async (
  practiceId: string,
  inviteId: string,
  userIdToRemove: string,
) => {
  return putData<PracticeInvite>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_INVITE_REMOVE_USER_ROUTE,
      { practiceId, inviteId, userId: userIdToRemove },
      { "api-version": "2.0" },
    ),
    {},
  )
}

const putPracticeInviteAddUserToAllDetached = async (
  userEmail: string,
  userIdToAdd: string,
) => {
  return putData<PracticeInvite[]>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_INVITE_ADD_USER_TO_ALL_DETACHED_ROUTE,
      undefined,
      { "api-version": "2.0" },
    ),
    {
      email: userEmail,
      userIdToLink: userIdToAdd,
    },
  )
}

const putPracticeRate = async (
  practiceId: string,
  practiceRate: Omit<PracticeRate, "createdBy" | "createdDate" | "isActive">,
) => {
  return putData<PracticeRate>(
    buildUrl(apiRoutes.put.PRACTICE_RATE_ROUTE, { practiceId }),
    practiceRate,
  )
}

export interface PutTaxInfoRequest extends Omit<
  PostTaxInfoRequest,
  "file" | "fileName"
> {}
export interface PutTaxInfoDto extends Omit<
  TaxInfoDto,
  "createdBy" | "createdDateTime" | "lastUpdatedBy" | "lastUpdatedDateTime"
> {}
const putPracticeTaxInformation = async (
  practiceId: string,
  taxId: string,
  taxInfo: PutTaxInfoRequest,
) => {
  return putData<TaxInfoDto>(
    buildUrl(apiRoutes.put.PRACTICE_TAX_INFORMATION, {
      practiceId,
      taxInfoId: taxId,
    }),
    taxInfo,
  )
}

const putPracticeActivation = async (practiceId: string) => {
  return putData(
    buildUrl(apiRoutes.put.PRACTICE_ACTIVATION_ROUTE, { practiceId }),
    {},
  )
}

const putPracticeAffiliateRoles = async ({
  affiliateId,
  roles,
  apiVersion = "2.0",
}: {
  affiliateId: string
  roles: PracticeRoleEnum[]
  apiVersion?: "2.0" | "3.0"
}) => {
  return putData<void>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_AFFILIATE_ROLES_ROUTE,
      { affiliateId },
      { "api-version": apiVersion },
    ),
    {
      id: affiliateId,
      roleDisplayIds: roles,
    },
  )
}

const putPracticeAffiliateStatus = async ({
  affiliateId,
  affiliateStatusDisplayId,
}: {
  affiliateId: string
  affiliateStatusDisplayId: PracticeAffiliateStatusEnum
}) => {
  return putData<PracticeAffiliate>(
    buildURLWithQueryParams(
      apiRoutes.put.PRACTICE_AFFILIATE_STATUS_ROUTE,
      { affiliateId },
      { "api-version": "2.0" },
    ),
    {
      id: affiliateId,
      statusDisplayId: affiliateStatusDisplayId,
    },
  )
}

const deletePracticeAffiliate = async ({
  affiliateId,
  apiVersion,
}: {
  affiliateId: string
  apiVersion?: "2.0"
}) => {
  return deleteData<void>(
    buildURLWithQueryParams(
      apiRoutes.delete.PRACTICE_AFFILIATE,
      { affiliateId },
      apiVersion ? { "api-version": apiVersion } : undefined,
    ),
  )
}

// The delete-invite endpoint exists only on v1, so it sends no api-version.
const deletePracticeInvite = async ({
  practiceId,
  inviteId,
}: {
  practiceId: string
  inviteId: string
}) => {
  return deleteData<void>(
    buildUrl(apiRoutes.delete.PRACTICE_INVITE, {
      practiceId,
      inviteId,
    }),
  )
}

export const practiceApi = {
  delete: {
    PRACTICE_AFFILIATE: deletePracticeAffiliate,
    PRACTICE_INVITE: deletePracticeInvite,
  },
  get: {
    ADP_SAML_BY_LEGACY_AFFILIATE_ID: adpSamlByLegacyAffiliateId,
    FULL_PRACTICE_BY_ID: fullPracticeById,
    FULL_PRACTICES_BY_IDS: fullPracticesByIds,
    PARTIAL_PRACTICE_BY_ID: partialPracticeById,
    PARTIAL_PRACTICES_BY_IDS: partialPracticesByIds,
    PARTIAL_PRACTICES_BY_IDS_BATCH: partialPracticesByIdsBatch,
    PRACTICE_ACTIVATION_DATA: practiceActivationData,
    PRACTICE_ACTIVE_RATE: practiceActiveRate,
    PRACTICE_AFFILIATES: practiceAffiliates,
    PRACTICE_AFFILIATES_BY_USER_ID: practiceAffiliatesByUserId,
    PRACTICE_AFFILIATES_BY_USER_IDS_BATCH: practiceAffiliatesByUserIdsBatch,
    PRACTICE_AFFILIATE_BY_PROVIDER_ID: practiceAffiliateByProviderId,
    PRACTICE_AGREEMENT_BY_PRACTICE_ID: practiceAgreementByPracticeId,
    PRACTICE_AGREEMENT_DOC: practiceAgreementDocument,
    PRACTICE_AGREEMENT_HISTORY: practiceAgreementHistory,
    PRACTICE_AUTH_AND_RELEASE_SIGNED_DOC: authAndReleaseSignedDoc,
    PRACTICE_BILLING_ADDRESS_BY_ID: practiceBillingAddressByPracticeId,
    PRACTICE_COMPLETENESS_BY_ID: practiceCompletenessById,
    PRACTICE_CONTACT_INFO_BY_ID: practiceContactInfoById,
    PRACTICE_DUPLICATE_TIN: checkDuplicateTaxId,
    PRACTICE_INVITE_BY_INVITE_ID: practiceInviteByInviteId,
    PRACTICE_INVITE_DETAILS_BY_INVITE_CODE: practiceInviteDetailsByInviteCode,
    PRACTICE_INVITES_BY_INVITE_ID: practiceInvitesByInviteId,
    PRACTICE_KNOX_KEENE_AGREEMENT_BY_PRACTICE_ID:
      practiceKnoxKeeneAgreementByPracticeId,
    PRACTICE_KNOX_KEENE_AGREEMENT_HISTORY: practiceKnoxKeeneAgreementHistory,
    PRACTICE_KNOX_KEENE_DOC: knoxKeeneDocument,
    PRACTICE_LIABILITY_INSURANCES_BY_ID: practiceLiabilityInsurancesById,
    PRACTICE_LOCATION_FULL_PHOTO: practiceLocationFullPhotoByPhotoId,
    PRACTICE_LOCATION_PHOTO_THUMBNAIL: practiceLocationThumbnailByPhotoId,
    PRACTICE_LOCATION_PHOTO_THUMBNAIL_AND_STATUS:
      fetchPracticeLocationPhotoThumbnail,
    PRACTICE_NAMES_BY_STATUS: practiceNamesByStatus,
    PRACTICE_NAMES_BY_USER_ID: practiceNamesByUserId,
    PRACTICE_NAMES_BY_UNREGISTERED_PROVIDER_ID:
      practiceNamesByUnregisteredProviderId,
    PRACTICE_PUBLIC_AFFILIATES_BY_ID: practicePublicAffiliates,
    PRACTICE_RATES: practiceRates,
    PRACTICE_ROLES_BY_USER_ID: practiceRolesByUserId,
    PRACTICE_ROLES_BY_UNREGISTERED_PROVIDER_ID:
      practiceRolesByUnregisteredProviderId,
    PRACTICE_TAGS_BY_ID: practiceTagsById,
    PRACTICE_TABLE_DATA: practiceTableData,
    PRACTICE_TAX_DOC: taxDocument,
    PRACTICE_TAX_INFO: taxInfo,
    PUBLIC_PRACTICE_BY_ID: publicPracticeById,
    PUBLIC_PRACTICES_BY_PROVIDER_PROVIDER_ID:
      publicPracticesByProviderProviderId,
    PUBLIC_PRACTICES_BY_PROVIDER_USER_ID: publicPracticesByProviderUserId,
    PRACTICE_BY_ID: practiceById,
  },
  post: {
    PRACTICE: postPractice,
    PRACTICE_INVITE: postPracticeInvite,
    PRACTICE_INVITE_ACCEPT: postAcceptPracticeInvite,
    PRACTICE_INVITE_DECLINE: postDeclinePracticeInvite,
    MANAGED_PRACTICE_AFFILIATE: postManagedPracticeAffiliate,
    PRACTICE_TAX_INFORMATION: postPracticeTaxInformation,
  },
  put: {
    ACTIVATE_PRACTICE: putPracticeActivation,
    PRACTICE_ADP_RECOVERY: putPracticeAdpRecovery,
    PRACTICE_AFFILIATE_ROLES: putPracticeAffiliateRoles,
    PRACTICE_AFFILIATE_STATUS: putPracticeAffiliateStatus,
    PRACTICE_INVITE: putPracticeInvite,
    PRACTICE_INVITE_ADD_USER: putPracticeInviteAddUser,
    PRACTICE_INVITE_ADD_USER_TO_ALL_DETACHED:
      putPracticeInviteAddUserToAllDetached,
    PRACTICE_INVITE_REMOVE_USER: putPracticeInviteRemoveUser,
    PRACTICE_RATE: putPracticeRate,
    PRACTICE_TAX_INFORMATION: putPracticeTaxInformation,
  },
}
